import { useProduct } from "src/context/ProductProvider";
import WeightLossProgressProjection from "./components/WeightLossProgressProjection";
import SkinCareProgressProjection from "../SkinCareProgressProjection";
import BetaBlockersProgressProjection from "../BetaBlockersProgressProjection";
import SupplementsProgressProjection from "../SupplementsProgressProjection";

const ProgressProjection = () => {
  const category = useProduct((p) => p.category.name);
  const slug = useProduct((p) => p.slug);

  if (category === "Weight Loss") {
    return <WeightLossProgressProjection />;
  }

  if (category === "Skin Care") {
    return <SkinCareProgressProjection />;
  }

  if (slug === "bb-ot") {
    return <BetaBlockersProgressProjection />;
  }

  if (["Supplements", "Sleep"].includes(category)) {
    return <SupplementsProgressProjection />;
  }

  return null;
};

export default ProgressProjection;
